<template>
  <div id="app">
    <router-view v-if="!loading"></router-view>
    <div v-if="loading" class="loader"></div>
  </div>
</template>

<script>

import {mapState} from 'vuex';

export default {
  name: 'app',
  data: function () {
    return {

    }
  },
  components: {

  },
  computed: {
    ...mapState(['loading'])
  },
  mounted: function(){
    this.$store.dispatch('fetchAuthState').then((data) => {
    
      if(!data.loggedIn){        
        if(this.$router.currentRoute.path != "/login"){
          this.$router.push('/login')          
        }
      }else{
        if(this.$router.currentRoute.path == "/"){
          this.$router.push('/list')          
        }
      }
    })
  },
  methods:  {

  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>